export const DEFAULT_MAX_FILE_SIZE_MB = 10
export const BYTES_PER_MB = 1024 * 1024

const positiveInteger = (value) => {
  const number = Number(value)
  return Number.isInteger(number) && number > 0 ? number : null
}

export const fileUploadPolicyFor = (currentUser = {}) => {
  const rawPolicy = currentUser.fileUploadPolicy || currentUser.file_upload_policy || {}
  const maxFileSizeMb = positiveInteger(
    rawPolicy.maxFileSizeMb || rawPolicy.max_file_size_mb
  ) || DEFAULT_MAX_FILE_SIZE_MB
  const maxFileSizeBytes = positiveInteger(
    rawPolicy.maxFileSizeBytes || rawPolicy.max_file_size_bytes
  ) || maxFileSizeMb * BYTES_PER_MB
  const maxFileSizeLabel = rawPolicy.maxFileSizeLabel ||
    rawPolicy.max_file_size_label ||
    `${maxFileSizeMb} MB`

  return { maxFileSizeMb, maxFileSizeBytes, maxFileSizeLabel }
}

export const validateFileUploadSize = (file, policy) => {
  if (!file || typeof file.size !== 'number') return null
  if (file.size <= policy.maxFileSizeBytes) return null

  const filename = file.name || 'archivo sin nombre'
  return `El archivo “${filename}” supera el tamaño máximo permitido de ${policy.maxFileSizeLabel}.`
}
